import graphql__adcd1ae8e73f8d19bb0f from "./__generated__/EmailLayoutList_query.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useFragment} from "react-relay/hooks";
import Table from "./presentational/table/Table";
import TableHeader from "./presentational/table/TableHeader";
import TableData from "./presentational/table/TableData";
import {resolvePath, useNavigate} from "react-router";
import {useIntl} from "react-intl";

type Props = {
    queryRef: any
    searchTerm?: string
}

const EmailLayoutList: React.FC<Props> = (props) => {
    const intl = useIntl();
    const data = useFragment(
        graphql__adcd1ae8e73f8d19bb0f,
        props.queryRef
    );
    const navigate = useNavigate();

    // Filter layouts by search term on client side
    const filteredLayouts = data.emailLayouts?.filter(layout => {
        if (props.searchTerm) {
            const searchLower = props.searchTerm.toLowerCase();
            if (!layout.name.toLowerCase().includes(searchLower)) {
                return false;
            }
        }
        return true;
    }) || [];

    if (filteredLayouts.length === 0) {
        return (
            <div className="px-6 pb-6 text-gray-500 text-center">
                {intl.formatMessage({id: 'view.emailLayouts.noEmailLayouts'})}
            </div>
        );
    }

    const formatDate = (dateString: string | null) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString();
    };

    return (
        <div className="flex-1 min-h-0 relative overflow-y-auto" aria-label={intl.formatMessage({id: 'navigation.emailLayouts'})}>
            <Table>
                <thead>
                    <tr>
                        <TableHeader>{intl.formatMessage({id: 'list.emailLayout.header.name'})}</TableHeader>
                        <TableHeader>{intl.formatMessage({id: 'list.emailLayout.header.isDefault'})}</TableHeader>
                        <TableHeader>{intl.formatMessage({id: 'list.emailLayout.header.createdAt'})}</TableHeader>
                        <TableHeader>{intl.formatMessage({id: 'list.emailLayout.header.updatedAt'})}</TableHeader>
                    </tr>
                </thead>
                <tbody>
                    {filteredLayouts.map(
                        (layout, index) => {
                            const handleRowClick = (event: React.MouseEvent) => {
                                const to = "/marketing/layouts/" + layout.id;
                                if (event.shiftKey || event.metaKey) {
                                    event.preventDefault();
                                    window.open(resolvePath(to).pathname);
                                } else {
                                    navigate(to);
                                }
                            };
                            return (
                                <tr
                                    key={layout.id}
                                    className={(index % 2 === 0 ? 'bg-white' : 'bg-gray-50') + ' hover:bg-gray-100 cursor-pointer'}
                                    onClick={handleRowClick}
                                >
                                    <TableData>
                                        <span className="font-medium">{layout.name}</span>
                                    </TableData>
                                    <TableData>
                                        {layout.isDefault ? (
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                                {intl.formatMessage({id: 'list.emailLayout.default'})}
                                            </span>
                                        ) : null}
                                    </TableData>
                                    <TableData>
                                        {formatDate(layout.createdAt)}
                                    </TableData>
                                    <TableData>
                                        {formatDate(layout.updatedAt)}
                                    </TableData>
                                </tr>
                            )
                        }
                    )}
                </tbody>
            </Table>
        </div>
    )
}

export default EmailLayoutList;
